

<script>



try {
  var _base = require("@/page/metareport/_base.vue").default;
} catch (err) {
  try {
    var _base = require("@/framework/page/metareport/_base.vue")
      .default;
  } catch (err) {}
}

export default {
  extends: _base,
  data() {
    return {
      
    };
  },
  methods: {
    acao1(id, row){
      return {
          name: (id, row)=>"Emline of "+id,
          action: (id, row) => {
              this.myself.loadingIntra=true;
              this.myself.callAction('identificador', id, {}, (res)=>{

                  this.refresh();
                  this.myself.displayAlertBox('Executado com sucesso! ' + '\n'+ res.actionreturn.msg)

              },(err)=>{
                
                  this.myself.displayErrorBox(err.message)

              })
          },
          html: (id, row)=>null
      }
    },

    acao2(objs, row){
      return {
          name: (objs, row)=>"Emmassa",
          action: (objs, row) => {


              if(objs.length==0){
                  this.myself.displayErrorBox("Nenhum registro selecionado!")
                  return;
              }
                          
              this.myself.loadingIntra=true;
              this.myself.callAction('identificador2', objs, {}, (res)=>{

                  this.refresh();
                  this.myself.displayAlertBox('Executado com sucesso! ' + '\n'+ res.actionreturn.msg)

              },(err)=>{
                
                  this.myself.displayErrorBox(err.message)

              })
          },
          html: (objs, row)=>null
      }
    },

    
  }
};
</script>

